import React, { useState } from "react";

const Footer = () => {
  const [openKey, setOpenKey] = useState("");
  const toggleOpen = (key) => setOpenKey(prev => prev === key ? "" : key);
  const year = new Date().getFullYear();
  return (
    <footer className="mt-5 border-top pt-5 bg-dark text-white">
      <div className="container">
        {/* Top: About + Trust + Contact */}
        <div className="row g-4">
          <div className="col-lg-5">
            <h5 className="fw-bold mb-2 text-white">About PrimeBrothers</h5>
            <p className="mb-2 small text-light">
              We’re a family-built ecommerce brand from Shikarpur, Sindh — on a mission to bring quality men’s and women’s clothing, and electronics (especially mobile accessories) at honest prices. Fast delivery, easy returns, and trusted support — that’s our promise.
            </p>
            <div className="small text-success d-flex align-items-center gap-2">
              <i className="fa fa-shield-halved"></i>
              <span>Trusted by 10,000+ customers</span>
            </div>
          </div>
          <div className="col-lg-4">
            <h5 className="fw-bold mb-2 text-white">Secure & Payments</h5>
            <div className="small text-light d-flex align-items-center gap-2 mb-2">
              <i className="fa fa-lock"></i>
              <span>Secure Checkout — 100% SSL Protected</span>
            </div>
            <div className="d-flex align-items-center gap-3 flex-wrap footer-payments">
              <i className="fa-brands fa-cc-visa fa-2x" aria-label="Visa"></i>
              <i className="fa-brands fa-cc-mastercard fa-2x" aria-label="MasterCard"></i>
              <i className="fa-brands fa-cc-paypal fa-2x" aria-label="PayPal"></i>
              <img src={process.env.PUBLIC_URL + '/assets/payments/jazzcash.svg'} height="28" alt="JazzCash" title="JazzCash" />
              <img src={process.env.PUBLIC_URL + '/assets/payments/easypaisa.svg'} height="28" alt="Easypaisa" title="Easypaisa" />
              <span className="badge bg-success">Cash on Delivery</span>
            </div>
          </div>
          <div className="col-lg-3">
            <h5 className="fw-bold mb-2 text-white">Contact</h5>
            <div className="small text-light">
              <div><strong>Head Office:</strong> District Shikarpur, Sindh, Pakistan</div>
              <div>Support: <a className="text-white" href="mailto:musmanmahar5312@gmail.com">musmanmahar5312@gmail.com</a></div>
            </div>
            <div className="mt-2 d-flex gap-3 align-items-center">
              <a className="text-white" href="https://www.facebook.com/share/16x1aTjsPA/" target="_blank" rel="noreferrer" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              <a className="text-success" href="https://wa.me/923048844719" target="_blank" rel="noreferrer" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
              <a className="text-white" href="https://www.linkedin.com/in/muhammad-usman-9464b5247?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a className="text-danger" href="https://www.instagram.com/m_usman73?igsh=MTJsZjV1N3o0cjFm" target="_blank" rel="noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>
        </div>

        <hr className="my-4 border-secondary" />

        {/* Legal links row */}
        <div className="row">
          <div className="col-12">
            <ul className="list-inline small m-0 text-light d-flex flex-wrap gap-3">
              <li className="list-inline-item">
                <button type="button" className="btn btn-link p-0 link-light text-decoration-none" onClick={()=> toggleOpen('privacy')} aria-expanded={openKey==='privacy'} aria-controls="footer-privacy">
                  Privacy Policy
                </button>
              </li>
              <li className="list-inline-item">
                <button type="button" className="btn btn-link p-0 link-light text-decoration-none" onClick={()=> toggleOpen('terms')} aria-expanded={openKey==='terms'} aria-controls="footer-terms">
                  Terms & Conditions
                </button>
              </li>
              <li className="list-inline-item">
                <button type="button" className="btn btn-link p-0 link-light text-decoration-none" onClick={()=> toggleOpen('refund')} aria-expanded={openKey==='refund'} aria-controls="footer-refund">
                  Refund / Return Policy
                </button>
              </li>
              <li className="list-inline-item">
                <button type="button" className="btn btn-link p-0 link-light text-decoration-none" onClick={()=> toggleOpen('cookies')} aria-expanded={openKey==='cookies'} aria-controls="footer-cookies">
                  Cookies Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Inline policy descriptions */}
        {openKey && (
          <div className="row mt-3">
            <div className="col-12">
              <div className="border rounded-3 p-3 bg-black bg-opacity-25">
                {openKey === 'privacy' && (
                  <div id="footer-privacy">
                    <h6 className="text-white mb-2">Privacy Policy</h6>
                    <p className="small text-light mb-2">
                      We respect your privacy. We collect only the information needed to process your orders and improve your experience. 
                      We never sell your personal data. Payments are handled by secure providers; card details aren’t stored on our servers.
                    </p>
                    <p className="small text-light mb-0">You can request your data or ask for deletion anytime. <a className="link-light" href="#/privacy">Read full policy</a>.</p>
                  </div>
                )}
                {openKey === 'terms' && (
                  <div id="footer-terms">
                    <h6 className="text-white mb-2">Terms & Conditions</h6>
                    <ul className="small text-light mb-0">
                      <li>Prices include applicable taxes unless stated otherwise.</li>
                      <li>Orders may be cancelled if items are unavailable or for suspected fraud.</li>
                      <li>By ordering, you agree to our delivery timelines and store policies.</li>
                    </ul>
                    <div className="small mt-2"><a className="link-light" href="#/terms">Read full terms</a>.</div>
                  </div>
                )}
                {openKey === 'refund' && (
                  <div id="footer-refund">
                    <h6 className="text-white mb-2">Refund / Return Policy</h6>
                    <ul className="small text-light mb-0">
                      <li>7-day easy returns for unused items in original packaging.</li>
                      <li>Refunds are issued within 5–7 working days to the original method.</li>
                      <li>COD refunds are processed via bank transfer or wallet.</li>
                    </ul>
                    <div className="small mt-2"><a className="link-light" href="#/refund">Read full policy</a>.</div>
                  </div>
                )}
                {openKey === 'cookies' && (
                  <div id="footer-cookies">
                    <h6 className="text-white mb-2">Cookies Policy</h6>
                    <p className="small text-light mb-2">
                      We use essential cookies for cart and checkout, and analytics cookies to improve performance. You can control cookies in your browser settings.
                    </p>
                    <div className="small"><a className="link-light" href="#/cookies">Learn more</a>.</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Bottom bar */}
      <div className="bg-black text-white mt-3">
        <div className="container py-3 d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <small>© {year} PrimeBrothers. All rights reserved.</small>
          <div className="footer-names">
            <div className="footer-names-track">
              Azhar Uddin • Naveed Ahmed • Waheed Ahmed • Atahar Uddin • Umar Farooq • Muhammad Usman • Kamran Ali • Imran Ali
              &nbsp;&nbsp;•&nbsp;&nbsp; Azhar Uddin • Naveed Ahmed • Waheed Ahmed • Atahar Uddin • Umar Farooq • Muhammad Usman • Kamran Ali • Imran Ali
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
